const artistSection = document.querySelector(".section-artist-overview");
if (!artistSection) return;

const artistGrid = artistSection.querySelector(".artist-grid");
const artistCards = artistSection.querySelectorAll(".artist-grid .artist");

const alphabetFilterButtons = artistSection.querySelectorAll(".search-and-alphabet-wrap .alpabet-filter");
const tagFilterButtons = artistSection.querySelectorAll(".tag-filters .tag-filter");
const sortSelect = artistSection.querySelector('select[name="sort_by"]')
const artistSearchBtn = artistSection.querySelector(".artist-search input");
const styleFilterAccordion = artistSection.querySelector(".style-tag-filter")
const newestTag = artistSection.querySelector('[data-tag="newest"]');
const upcomingTag = artistSection.querySelector('[data-tag="upcoming"]');

alphabetFilterButtons.forEach(btn => btn.addEventListener("click", () => setFilterStatus("alphabet", btn)));
tagFilterButtons.forEach(btn => btn.addEventListener("click", () => setFilterStatus("tag", btn)));
sortSelect.addEventListener("change", () => { sortArtists(sortSelect.value) })
artistSearchBtn.addEventListener("input", searchArtists);
styleFilterAccordion.addEventListener("click", openAccordion);

function openAccordion() {
    styleFilterAccordion.querySelector(".filter-dropdown").addEventListener("mouseenter", () => {
        styleFilterAccordion.querySelector(".filter-dropdown").addEventListener("mouseleave", closeAccordion)
    })
    artistSection.querySelector(".tag-filter-and-sort-wrap-inner").addEventListener("scroll", closeAccordion);
}

function closeAccordion() {
    styleFilterAccordion.removeAttribute("open");
    styleFilterAccordion.removeEventListener("mouseleave", closeAccordion);
    artistSection.querySelector(".tag-filter-and-sort-wrap-inner").removeEventListener("scroll", closeAccordion);
}

function setFilterStatus(type, btn) {
    let isActiveAllButton;
    let allFilters;
    let filterValue;

    if (type == "alphabet") {
        isActiveAllButton = artistSection.querySelector('.search-and-alphabet-wrap [data-letter="all"]');
        allFilters = alphabetFilterButtons;
        filterValue = btn.dataset.letter;

        tagFilterButtons.forEach(btn => btn.dataset.isActive = "false");
        artistSection.querySelector('.tag-filters [data-tag="all"]').dataset.isActive = "true";
    } else if (type == "tag") {
        isActiveAllButton = artistSection.querySelector('.tag-filters [data-tag="all"]');
        allFilters = tagFilterButtons;
        filterValue = btn.dataset.tag;

        alphabetFilterButtons.forEach(btn => btn.dataset.isActive = "false");
        artistSection.querySelector('.search-and-alphabet-wrap [data-letter="all"]').dataset.isActive = "true";
    }

    if (filterValue === "all") {
        allFilters.forEach(btn => btn.dataset.isActive = "false");
        isActiveAllButton.dataset.isActive = "true";
    }
    else if (filterValue == "newest") {
        if (btn.dataset.isActive === "false") upcomingTag.dataset.isActive = "false";
        if (btn.dataset.isActive === "false") isActiveAllButton.dataset.isActive = "false";
        btn.dataset.isActive = btn.dataset.isActive === "true" ? "false" : "true";
    }
    else if (filterValue == "upcoming") {
        if (btn.dataset.isActive === "false") newestTag.dataset.isActive = "false";
        if (btn.dataset.isActive === "false") isActiveAllButton.dataset.isActive = "false";
        btn.dataset.isActive = btn.dataset.isActive === "true" ? "false" : "true";
    }
    else {
        isActiveAllButton.dataset.isActive = "false";
        btn.dataset.isActive = btn.dataset.isActive === "true" ? "false" : "true";
    }

    if (type == "alphabet") filterByLetters();
    if (type == "tag") filterByTags();
}

function filterByTags() {
    const activeFilters = artistSection.querySelectorAll('.tag-filter[data-is-active="true"]');
    const activeStyleFilters = artistSection.querySelectorAll('.style-tag-filter .tag-filter[data-is-active="true"]');
    const activeArtistFilters = artistSection.querySelectorAll('.artist-tag.tag-filter[data-is-active="true"]');
    let activeTags = "";
    let activeStyleTags = "";
    let activeArtistTags = "";
    let cardsVisible = false;

    activeFilters.forEach(filter => { if (filter.dataset.tag != "all") { activeTags = activeTags + filter.dataset.tag; } })
    activeStyleFilters.forEach(filter => { if (filter.dataset.tag != "all") { activeStyleTags = activeStyleTags + filter.dataset.tag; } })
    activeArtistFilters.forEach(filter => { if (filter.dataset.tag != "all") { activeArtistTags = activeArtistTags + filter.dataset.tag; } })

    if (activeTags != "") {
        if (activeTags.includes("newest")) sortArtists("newToOld");
        if (activeTags.includes("upcoming")) sortArtists("oldToNew");

        artistCards.forEach(card => {
            let showcard = true;

            if (activeTags.includes("newest")) {
                if (card.getAttribute('data-artist-active-for-x-days') < 0) showcard = false;
            }
            if (activeTags.includes("upcoming")) {
                if (card.getAttribute('data-artist-active-for-x-days') > 0) showcard = false;
            }
            if (styleFilterAccordion && activeStyleTags != "") {
                const artistStyleTags = card.getAttribute('data-style-tags').split(",");
                let hasOneOfStyleTags = false;
                artistStyleTags.forEach(tag => { if (activeStyleTags.includes(tag)) hasOneOfStyleTags = true });
                if (!hasOneOfStyleTags) showcard = false;
            }
            if (activeArtistTags != "") {
                const artistTags = card.getAttribute('data-artist-tags').split(",");
                let hasOneOfArtistTags = false;
                if (artistTags != "") artistTags.forEach(tag => { if (activeArtistTags.includes(tag)) { hasOneOfArtistTags = true } });
                if (!hasOneOfArtistTags) showcard = false;
            }

            if (showcard) cardsVisible = true;
            card.classList.toggle("hidden", !showcard);
        })
    } else {
        artistSection.querySelector('.tag-filters [data-tag="all"]').dataset.isActive = "true";
        artistCards.forEach(card => { card.classList.remove("hidden") })
        cardsVisible = true;
    }

    if (activeTags.includes("newest")) {
        let activeArtistIndex = 0;
        artistSection.querySelectorAll(".artist-grid .artist").forEach(card => {
            if (card.getAttribute('data-artist-active-for-x-days') > 0) {
                activeArtistIndex++;
                if (activeArtistIndex > 12) card.classList.add("hidden");
            }
        })
    }

    toggleNoResultsMessage(cardsVisible);
}

function sortArtists(type) {
    sortSelect.value = type;

    if (type == "newToOld") {
        Array.from(artistGrid.querySelectorAll('.artist')).sort((a, b) => {
            return +a.getAttribute('data-artist-active-for-x-days') - +b.getAttribute('data-artist-active-for-x-days');
        }).forEach(element => artistGrid.appendChild(element));
    } else if (type == "oldToNew") {
        Array.from(artistGrid.querySelectorAll('.artist')).sort((a, b) => {
            return +b.getAttribute('data-artist-active-for-x-days') - +a.getAttribute('data-artist-active-for-x-days');
        }).forEach(element => artistGrid.appendChild(element));
    } else if (type == "default") {
        Array.from(artistGrid.querySelectorAll('.artist')).sort((a, b) => {
            return +a.getAttribute('data-original-order') - +b.getAttribute('data-original-order');
        }).forEach(element => artistGrid.appendChild(element));
    } else if (type == "az") {
        Array.from(artistGrid.querySelectorAll('.artist')).sort((a, b) => {
            return getArtistName(a).localeCompare(getArtistName(b));
        }).forEach(element => artistGrid.appendChild(element));
    } else if (type == "za") {
        Array.from(artistGrid.querySelectorAll('.artist')).sort((a, b) => {
            return getArtistName(b).localeCompare(getArtistName(a));
        }).forEach(element => artistGrid.appendChild(element));
    }

    function getArtistName(element) {
        const textElement = element.querySelector('.artist-name');
        return textElement ? textElement.textContent.trim() : '';
    }
}

function filterByLetters() {
    const activeFilters = artistSection.querySelectorAll('.alpabet-filter[data-is-active="true"]')
    let activeLetters = "";

    activeFilters.forEach(filter => { if (filter.dataset.letter != "all") { activeLetters = activeLetters + filter.dataset.letter; } })

    if (activeLetters != "") {
        artistCards.forEach(card => {
            const filterByLetters = card.dataset.filterLetters.split("");
            let showcard = false;
            filterByLetters.forEach(letter => {
                if (activeLetters.includes(letter.toLowerCase())) showcard = true;
            })
            card.classList.toggle("hidden", !showcard);
        })
    } else {
        artistSection.querySelector('.search-and-alphabet-wrap [data-letter="all"]').dataset.isActive = "true";
        artistCards.forEach(card => { card.classList.remove("hidden") })
    }
    toggleNoResultsMessage(true)
}

function toggleNoResultsMessage(cardsVisible) {
    artistSection.querySelector(".section-artist-overview .no-results-message").classList.toggle("hidden", cardsVisible);
}

function searchArtists(e) {
    const searchTerm = e.target.value.toLowerCase();
    let cardsVisible = false;

    artistCards.forEach(card => {
        const artistName = card.dataset.artistName.toLowerCase();
        cardsVisible = cardsVisible || artistName.includes(searchTerm);
        card.classList.toggle("hidden", !artistName.includes(searchTerm));
    });

    alphabetFilterButtons.forEach(btn => btn.dataset.isActive = "false");
    artistSection.querySelector('.search-and-alphabet-wrap [data-letter="all"]').dataset.isActive = "true";

    toggleNoResultsMessage(cardsVisible);
}
